import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { FieldDefinition } from '@examdojo/core/ontology';
import { MarkdownModule } from 'ngx-markdown';
import { FieldTypeService } from '../field-type.service';

@Component({
  selector: 'exam-type-badge',
  standalone: true,
  imports: [NgClass, MatMenuModule, MarkdownModule],
  templateUrl: './type-badge.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TypeBadgeComponent {
  private readonly fieldTypeService = inject(FieldTypeService);

  readonly field = input.required<FieldDefinition>();
  readonly inactive = input(false);
  readonly clickable = input(true);

  readonly typeLabel = computed(() => this.fieldTypeService.getFieldTypeLabel(this.field()));

  readonly badgeClasses = computed(() => {
    if (this.inactive()) {
      return { 'bg-gray-100': true, 'text-gray-400': true };
    }
    return this.fieldTypeService.getTypeBadgeClasses(this.field());
  });

  readonly typeInfo = computed(() => this.fieldTypeService.getPrimitiveTypeInfo(this.field()));

  readonly katexOptions = this.fieldTypeService.katexOptions;
}
